import { render } from "./PackReview.vue?vue&type=template&id=fa80f762"
import script from "./PackReview.vue?vue&type=script&lang=js"
export * from "./PackReview.vue?vue&type=script&lang=js"

import "./PackReview.vue?vue&type=style&index=0&id=fa80f762&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__